// extracted by mini-css-extract-plugin
export var centerText = "_cf-8";
export var container = "_cf-0";
export var doughnutContainer = "_cf-7";
export var legend = "_cf-a";
export var legendItemColorDisplay = "_cf-b";
export var legendItemLabel = "_cf-d";
export var legendItemValue = "_cf-c";
export var lg = "_cf-5";
export var maxWidth = "_cf-9";
export var md = "_cf-4";
export var responsive = "_cf-6";
export var sm = "_cf-3";
export var xs = "_cf-2";
export var xxs = "_cf-1";